<a [href]="href" target="_blank" rel="noopener noreferrer">
  <ng-content></ng-content>
</a>
